import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { patientActions } from '../../../redux/patient'
import PatientsViewer from './PatientsViewer'
import testPatients from '../../../testData/testPatients'
import Patient from '../../../models/Patient/Patient'
import withPolyglot from '../../common/withPolyglot'

class PatientsViewerContainer extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      recentPatients: []
    }
  }

  componentDidMount () {
    const patients = []
    testPatients.forEach(patient => {
      const {id, name, birthDate, gender, photo, country, immunizations, plan} = patient
      patients.push(new Patient(id, name, birthDate, gender, photo, country, immunizations, plan))
    })
    this.setState({
      recentPatients: patients
    })
  }
  render () {
    return <PatientsViewer
      patients={this.state.recentPatients}
      match={this.props.match} />
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators(patientActions, dispatch)
}

export default connect(null, mapDispatchToProps)(withPolyglot(PatientsViewerContainer, 'patientsViewer'))
